module.exports = __webpack_public_path__ + "img/Laadpalen.a63ef261.svg";